
import React, { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { IzakayaHero } from './components/IzakayaHero';
import { IzakayaBadgeBanner } from './components/IzakayaBadgeBanner';
import { IzakayaConcept } from './components/IzakayaConcept';
import { IzakayaTimeline } from './components/IzakayaTimeline';
import { IzakayaArea } from './components/IzakayaArea';
import { IzakayaShops } from './components/IzakayaShops';
import { IzakayaGallery } from './components/IzakayaGallery';
import { IzakayaPricing } from './components/IzakayaPricing';
import { IzakayaFaq } from './components/IzakayaFaq';
import { IzakayaNotice } from './components/IzakayaNotice';
import { IzakayaWhatsAppButton } from './components/IzakayaWhatsAppButton';
import { IzakayaFinalCta } from './components/IzakayaFinalCta';

export default function TokyoIzakayaNightPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <IzakayaHero lang="ja" />
      <IzakayaBadgeBanner lang="ja" />
      <IzakayaConcept lang="ja" />
      <IzakayaTimeline lang="ja" />
      <IzakayaArea lang="ja" />
      <IzakayaShops lang="ja" />
      <IzakayaGallery lang="ja" />
      <IzakayaPricing lang="ja" />
      <IzakayaFaq lang="ja" />
      <IzakayaFinalCta lang="ja" />
      <IzakayaNotice lang="ja" />
      <IzakayaWhatsAppButton lang="ja" />
      <Footer />
    </div>
  );
}
